
<template>
    <div class="model-content" style="display: flex; justify-content: center;">
        <div class="model5">
            <div>
                <img v-if="posterList.lang == 'ug' || !posterList.lang" style="width: 100%;height: 100%;" :src="moban_list.url_ug" />
                <img v-if="posterList.lang == 'zh'" style="width: 100%;height: 100%;" :src="moban_list.url_zh" />
            </div>
            <div class="top-container">
                <div class="merchant-name" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl' : ' zh-font'">
                    <div class='merchant-name-title'>
                        {{ posterList.merchant_name }}
                    </div>
                </div>
            </div>

            <div class="food_name" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl' : ''">
                    <div class="food_name_text">{{ posterList.food_name }}</div>
                </div>
                <div class="food_img">
                    <img :src="posterList.food_img" alt="">
                </div>
                <div class="food_price" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl' : ''">
                    <span style="font-size:32px">{{ posterList.food_price }}</span><span style="font-size: 40px;">￥</span>
                </div>
                <div class="old_price"
                    :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl old_price_ug' : 'old_price_zh'">
                    <span>{{ posterList.old_price }}</span><span>￥</span>
                </div>

            <div class="date-time" v-if="posterList.date">
                <div class="date-item">
                    <span> {{ posterList.date }}</span>
                </div>
            </div>
            <div class="merchant_qrcode"
                :class="(posterList.lang == 'ug' || !posterList.lang) ? 'merchant_qrcode_ug' : 'merchant_qrcode_zh'">
                <img :src="posterList.merchant_qrcode" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "model_15",
    data() {
        return {
            posterList: {},
            moban_list: {
                url_zh: require('../../img/poster/modelzh_16.jpg'),
                url_ug: require('../../img/poster/modelug_16.jpg'),
            },
        };
    },
    created() {
        this.canvasfortitle(this.$route.query.merchant_name, this.$route.query.food_name, this.$route.query)
    },
    methods: {
        canvasfortitle(merchant_name, food_names, query) {
            let res_name = merchant_name.replaceAll('(', '-')
            res_name = res_name.replaceAll('（', '-')
            res_name = res_name.replaceAll(')', ' ')
            res_name = res_name.replaceAll('）', ' ')
            let food_name = food_names.replaceAll('(', '-')
            food_name = food_name.replaceAll('（', '-')
            food_name = food_name.replaceAll(')', ' ')
            food_name = food_name.replaceAll('）', ' ')
            this.posterList = query;
            this.posterList['merchant_name'] = res_name;
            this.posterList['food_name'] = food_name;
        },
    },
};
</script>
  
<style scoped>
.model-content {
    width: 414px;
    height: 769px;
    position: relative;
    margin: auto;
}

.model5 {
    width: 414px;
    height: 769px;
    position: relative;
}

.rtl {
    direction: rtl;
}

.top-container {
    position: absolute;
    z-index: 999;
    top: 190px;
    width: 300px;
    left: calc(50% - 150px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.merchant-name {
    position: relative;
    color: #5dcd26;
    width: 400px;
    height: 30px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.merchant-name-title {
    font-size: 22px;
    width: 100%;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 5px;
}

.food_name {
    position: absolute;
    width: 300px;
    top: 265px;
    right: 57px;
    font-size: 18px;
    color: #fff;
}

.food_name_text {
    width: 100%;
    display: -webkit-box;
    text-align: center;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
}

.food_img {
    position: absolute;
    top: 324px;
    left: 86px;
    width: 258px;
    height: 259px;
    border-radius: 50%;
    overflow: hidden;
}

.food_img img {
    width: 100%;
    height: 100%;
}

.food_price {
    position: absolute;
    top: 530PX;
    left: 12px;
    color: #6d4214;
    width: 130px;
    text-align: center;
    line-height: 45px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
}

.old_price {
    position: absolute;
    font-size: 14px;
    color: #fff;
    text-decoration: line-through;
}

.old_price_ug {
    bottom: 146px;
    right: 227px;
}

.old_price_zh {
    bottom: 150px;
    left: 244px;
}

.date-time {
    position: absolute;
    top: 229px;
    left: 57px;
    width: 300px;
    height: 25px;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    font-weight: 600;
    justify-content: center;
}

.date-item {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding: 0 4px;
}

.date-title {
    padding: 0 5px;
}

.merchant_qrcode {
    position: absolute;
    bottom: 18px;
    right: 64px;
    width: 80px;
    height: 80px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
    padding: 3px;
    box-sizing: border-box;
}

.merchant_qrcode img {
    width: 100%;
    height: 100%;
}
</style>